import React from 'react';
import { Banner, Button } from '@shopify/polaris';

const SucessBanner = (props) => {
  return (
    <>
      <Banner {...props} status='success'>
        <Button url={props.portalUrl} external plain>
          {props.portalBody}
        </Button>
        {' or '}
        <Button plain onClick={() => { props.history.push(props.detailsUrl); }}>
          {props.detailsBody}
        </Button>
        .
      </Banner>
      <br />
    </>
  );
};

export default SucessBanner;
